// A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review.
/**
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns {Date[]}
 */
export function getAllYears(startDate, endDate) {
  const years = [];
  const startYear = startDate.getFullYear();
  const endYear = endDate.getFullYear();

  for (let year = startYear; year <= endYear; year++) {
    years.push(new Date(year, 0, 1)); // January 1st of each year
  }

  return years;
}
